import { css, extractShadow, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  wrapper: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    min-height: min-content;

    @media (max-width: 768px) {
      align-items: flex-start;
      overflow-x: hidden;
      overflow-y: visible;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  `,
  messageContainerWrapper: css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 64px);
    width: 100%;
  `,
  messageContainer: ({ theme }) => css`
    background-color: ${theme.colors.neutral.variant[0]};
    border-radius: 16px;
    padding: 32px 24px;
    width: 550px;
    box-shadow: ${extractShadow((s) => s.robin2)};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    text-align: center;
  `,
  iconContainer: ({ theme }) => css`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.secondary.emerald[10]};
    color: ${theme.colors.secondary.emerald[50]};
  `,
  textContainer: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  schedulerContainer: css`
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 50%;
    margin-top: calc(calc(100vh - 762px) * 0.3);

    @media (max-height: 786px) and (min-width: 769px) {
      transform: scale(0.9);
      margin: -1% 50%;
      margin-top: -34.9px;
    }

    @media (max-height: 700px) and (min-width: 769px) {
      transform: scale(0.85);
      margin: 0 50%;
      margin-top: -52.35px;
      padding: 12px 0px;
    }

    @media (max-height: 600px) and (min-width: 769px) {
      transform: scale(0.8);
      margin: 0 50%;
      margin-top: -69.8px;
    }

    @media (max-height: 564px) and (min-width: 769px) {
      transform: scale(0.7);
      margin: 0 50%;
      margin-top: -104.7px;
    }

    @media (max-width: 768px) {
      padding: 14px 0px;
      margin: 0;
      width: 100%;
      min-height: 0;
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
